import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface UpdateGLCodeAttributesRequest {
  glCodeIds: number[];
  poApprovalStatus: number;
  invoiceApprovalStatus: number;
  poApprovalUsers: number[];
  invoiceApprovalUsers: number[];
}

const useUpdateGLCodeAttributesApi = () => {
  const call = useCallback(async (request?: UpdateGLCodeAttributesRequest) => {
    try {
      const res = await axiosInstance.post<UpdateGLCodeAttributesRequest[]>(
        api.updateGLCodeAttributes,
        {
          glCodeIds: request?.glCodeIds,
          poApprovalStatus: request?.poApprovalStatus,
          invoiceApprovalStatus: request?.invoiceApprovalStatus,
          poApprovalUsers: request?.poApprovalUsers,
          invoiceApprovalUsers: request?.invoiceApprovalUsers,
        }
      );
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { execute, isLoading } = useAsync(call, false);

  return {
    updateGLCodeAttributes: execute,
    isUpdatingGLCodeAttributes: isLoading,
  };
};

export default useUpdateGLCodeAttributesApi;
